export const bonus = {
  INDEX: '/bonus',
  CREATE_BONUS: '/bonus/create',
  UPDATE_BONUS_ID: '/bonus/update/:id',
  UPDATE_BONUS: '/bonus/update',
  DUPLICATE_BONUS_ID: '/bonus/duplicate/:id',
  DUPLICATE_BONUS: '/bonus/duplicate',
}
